@import "../../../globalStyles/commons";

:host {
  display: block;
}

.tree-node-content {
  cursor: pointer;
  height: 2rem;
  padding-inline-end: calc(v(--spacing-05) - 0.125rem);
  box-sizing: border-box;
  outline: none;
  display: flex;
  align-items: center;
  position: relative;
  border: 0.125rem solid transparent;

  .tree-node-label {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: .5rem;
    color: v(--text-secondary);
    @include font-style(body-compact-01);
  }

  .expand-icon {
    transform: rotate(0deg);
    transition: all .11s cubic-bezier(.2, 0, .38, .9);
  }

  .expand-icon.expanded {
    transform: rotate(+90deg);
  }

  .icon-space {
    width: v(--spacing-05);
  }

  .icon {
    padding-inline-start: .5rem;
  }
}

.node-slot {
  display: none;
}

.node-slot.expanded {
  display: block;
}

.tree-node-content {
  text-decoration: none !important;

  &:hover {
    background: v(--layer-hover);

    &.selected {
      background: var(--layer-selected-hover);
    }
  }

  &.has-focus:not(.selected) {
    color: var(--text-primary);
    border-color: v(--color-primary);

    .slot-end {
      color: var(--icon-01);
    }
  }

  &.selected {
    background: var(--layer-selected);
    font-weight: var(--font-weight-semi-bold);
    border-left: 0.125rem solid transparent;
  }


  &.selected::before {
    content: " ";
    display: block;
    height: calc(100% + 0.25rem);
    border-left: 0.25rem solid var(--color-primary, v(--color-blue-60)) !important;
    position: absolute;
    top: -0.125rem;
    left: -0.125rem;
  }

}

.tree-node-content.disabled {
  cursor: not-allowed;
  color: var(--text-disabled) !important;
  background-color: var(--disabled-01) !important;

  &:hover, &.has-focus:not(.selected) {
    color: var(--text-disabled) !important;
    background-color: var(--disabled-01) !important;
  }

  &.selected {
    color: var(--text-disabled) !important;
    background-color: var(--disabled-01) !important;
  }
}
